import { createContext } from 'react'

import type { StoredSession } from './session'

export interface AuthContextValue {
  /** null quando non c'è nessuno autenticato. */
  session: StoredSession | null
  login: (input: { username: string; password: string }) => Promise<void>
  logout: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
